import React, { useState } from "react";

import { Container, Row, Col } from "react-bootstrap";
import Skeleton from "@material-ui/lab/Skeleton";

import TvIcon from "@material-ui/icons/Tv";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { eliminarInstitutoClassics } from "../../../shared/fetchers/classics/institutos/eliminarInstituto";
import { fetchInstitutos } from "../../../shared/fetchers/classics/institutos/verInstitutos";
import swal from "sweetalert";
import { toast } from "react-hot-toast";
import { CheckRounded, CloseRounded } from "@material-ui/icons";

const EliminarInstitutoClassics = () => {
  const [instituto, setInstituto] = useState(null);

  const {
    data: institutos,
    isLoading,
    isError,
  } = useQuery(["institutosClassics"], fetchInstitutos);

  const queryClient = useQueryClient();

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError) return <div>Ha ocurrido un error</div>;

  const SubmitForm = async (e) => {
    e.preventDefault();

    const check = await swal({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar este instituto",
      icon: "warning",
      buttons: ["Cancelar", "Eliminar"],
      dangerMode: true,
    });

    if (!instituto || !check) return toast.success("Operación cancelada");

    const { info, status } = await eliminarInstitutoClassics(
      instituto?.nombre ?? ""
    );

    if (!status)
      return swal({
        title: "Error",
        text: info ?? "Ha ocurrido un error eliminando el instituto",
        icon: "error",
      });

    queryClient.invalidateQueries({
      queryKey: ["institutosClassics"],
    });

    toast.success("Instituto eliminado correctamente");

    setInstituto(null);
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <TvIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Eliminar un instituto</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <form>
              <label className="admin-label-text mt-3 d-block">
                Selecciona un instituto:
              </label>
              <Autocomplete
                options={institutos}
                value={instituto}
                getOptionLabel={(option) => option.nombre}
                onChange={(_, newValue) => {
                  setInstituto(newValue);
                }}
                noOptionsText="Sin resultados"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    style={{
                      width: "100%",
                      fontFamily: "'Noto Sans JP', sans-serif",
                    }}
                  />
                )}
              />
              <div className="d-flex justify-content-end mt-4">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!instituto}
                  type="submit"
                  onClick={(e) => SubmitForm(e)}
                  startIcon={<CheckRounded />}
                  style={{ background: "#f05050" }}
                >
                  Eliminar
                </Button>
                <Button
                  variant="contained"
                  disabled={!instituto}
                  color="primary"
                  onClick={() => {
                    setInstituto(null);
                  }}
                  className="ml-2"
                  startIcon={<CloseRounded style={{ fontSize: "25px" }} />}
                  style={{ background: "#81c868" }}
                >
                  Cancelar
                </Button>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EliminarInstitutoClassics;
